import React, { useState } from 'react'
import SendMessageSvg from '../other/svg/SendMessageSvg'
import View from '../atoms/View'
import { useDispatch } from 'react-redux'
import { CREATE_MESSAGE } from 'dealer-reducers'
import { useTranslation } from 'react-i18next'
interface Props {
  offerHashId: string
  variant?: 'OfferMessage' | 'ConversationMessage'
}

const MessageInput = ({ offerHashId, variant = 'ConversationMessage' }: Props): JSX.Element => {
  const { t } = useTranslation()
  const [messageBody, setMessageBody] = useState('')
  const dispatch = useDispatch()

  const handleSendMessage = (): void => {
    dispatch(CREATE_MESSAGE({ offer_hash_id: offerHashId, body: messageBody }))
    setMessageBody('')
  }
  const containerStyles = `flex bg-lightGrey focus:shadow-[0px_0px_5px_rgba(0,0,0,0.3)] rounded-[15px] overflow-hidden'
  }`

  const inputStyles = 'bg-lightGrey  h-[49px] text-xl outline-none box-border w-full rounded-[15px] px-3'
  return (
    <div className={containerStyles}>
      <input
        onChange={(e) => {
          setMessageBody(e.target.value)
        }}
        value={messageBody}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            handleSendMessage()
          }
        }}
        className={inputStyles}
        placeholder={t('message_placeholder')}
      />
      <View
        onClick={() => {
          handleSendMessage()
        }}
        className="flex justify-center items-center pl-1 rounded-[15px] rounded-r-none w-14 bg-successGreen">
        <SendMessageSvg className="w-6 h-6 text-white cursor-pointer" />
      </View>
    </div>
  )
}

export default MessageInput
